import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/videoReviews',
        name: 'videoReviews',
        meta: { sideMenuLabel: "Video recensioni" },
        component: () => import("./views/videoReviews.vue")
    },
];

export default routes;